import { defineComponent, inject, h } from 'vue';
import { CCollapse } from '../collapse/CCollapse.js';

const CAccordionBody = defineComponent({
    name: 'CAccordionBody',
    setup(_, { slots }) {
        const visible = inject('visible');
        return () => h(CCollapse, { class: 'accordion-collapse', visible: visible.value }, {
            default: () => h('div', { class: ['accordion-body'] }, slots.default && slots.default()),
        });
    },
});

export { CAccordionBody };
//# sourceMappingURL=CAccordionBody.js.map
